export const GetJournalViewDetailList = (journalViewDetailRawList: any) => {
  const journalViewDetailList = [];
  if (journalViewDetailRawList && journalViewDetailRawList.length > 0) {
    for (const journalViewDetailRaw of journalViewDetailRawList) {
      journalViewDetailList.push({
        id: journalViewDetailRaw.id,
        number: journalViewDetailRaw.number,
        contactId: journalViewDetailRaw.contactId,
        date: journalViewDetailRaw.date,
      });
    }
  }
  return journalViewDetailList;
};
